import React from 'react'
import cn from 'classnames'

export const ActionCallButton = ({ action, icon, text, isActive, disabled, iconHeight, className = '', iconClass = '' }) => {
    const Icon = icon

    return (
        <button type="button" onClick={action} disabled={disabled} className="call__action-btn">
            <Icon
                className={cn(
                    `call__action-btn__icon ${className}`,
                    isActive && 'call__action-btn__icon--active',
                    disabled && 'call__action-btn__icon--disabled',
                    iconClass
                )}
                style={{ height: iconHeight }}
            />
            <span
                className={cn(
                    'call__action-btn__text',
                    isActive && 'call__action-btn__text--active',
                    disabled && 'call__action-btn__text--disabled'
                )}
            >
                {text}
            </span>
        </button>
    )
}
